export const getShowNewSearcher = (pathname) => (
  pathname.includes('/manage') ||
  pathname.includes('/host') ||
  pathname.includes('/knowledge_base') ||
  pathname.includes('/vulnerabilities') ||
  pathname.includes('/workspaces') ||
  pathname.includes('/services') ||
  pathname.includes('/service') ||
  pathname.includes('/report') ||
  pathname.includes('/automation/schedule') ||
  pathname.includes('/credentials') ||
  pathname.startsWith('/automation/agents')
);

export const getShowSaveFilter = (pathname) => (
  !pathname.includes('/workspaces') &&
  !pathname.includes('/services') &&
  !pathname.includes('/service') &&
  !pathname.includes('/knowledge_base')
);
